export const CommunicationTypeEnum = Object.freeze({
  Registration: 1,
  FollowUp: 2
});
